import supabaseClient from '@/api/supabaseClient.ts';
import { FunctionsHttpError } from '@supabase/supabase-js';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { FrameworkRouteCommitRequest, FrameworkRouteResponse } from '$/requests/FrameworkRoute.ts';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';

const useFrameworkRoute = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: FrameworkRouteCommitRequest) => submitFrameworkRouteCommit(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['decisions'] });
    },
  });
};

export default useFrameworkRoute;

async function submitFrameworkRouteCommit(
  body: FrameworkRouteCommitRequest,
): Promise<FrameworkRouteResponse> {
  const { data, error } = await supabaseClient.functions.invoke('framework-route', { body });

  if (error && error instanceof FunctionsHttpError) {
    const errorResponse: BackendErrorResponse = await error.context.json();
    throw new Error(errorResponse.errors?.join(', ') ?? 'Diagnostic commit failed');
  }

  return data.data as FrameworkRouteResponse;
}
